import { createContext, useContext } from 'react'

/**
 * Ausência de provider significa **editável**, que é o comportamento de hoje.
 * Toda tela que já renderiza esses painéis continua igual sem tocar em nada; só
 * quem envolve a árvore no provider abre mão das ações de escrita.
 */
const CampaignReadOnlyContext = createContext(false)

/**
 * Marca a subárvore como leitura de campanha.
 *
 * Existe porque as afordâncias de escrita dos painéis compartilhados não são
 * decididas por prop: `InfoView` e `Budget` derivam de `canEditCampaign`, que
 * vem do Redux, e as de dentro das tabelas (`HandleAdsActive`, `EditBudget`,
 * `BidStrength`, `ToggleActiveCampaignProduct`) são renderizadas por funções de
 * schema, longe de qualquer prop que a página pudesse passar. Contexto é o
 * único caminho que alcança todas sem enfiar prop por cinco camadas.
 *
 * Não confundir com `isReadOnly()`, que é o papel `read_only` do token: aquele
 * fala de quem é o usuário, este fala do que a tela se propõe a fazer.
 */
export const CampaignReadOnlyProvider = ({
  children
}: React.PropsWithChildren) => (
  <CampaignReadOnlyContext.Provider value>
    {children}
  </CampaignReadOnlyContext.Provider>
)

export const useCampaignReadOnly = () => useContext(CampaignReadOnlyContext)
